(() => {
  if (window.__REEVYS_PRODUCT_INTELLIGENCE_V4__) return;
  window.__REEVYS_PRODUCT_INTELLIGENCE_V4__ = true;

  const SYSTEMS = ['US', 'UK', 'EU', 'AU', 'BR'];
  const EU = new Set([
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IS','IT',
    'LV','LI','LT','LU','MT','NL','NO','PL','PT','RO','SK','SI','ES','SE','CH'
  ]);

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const norm = (value) =>
    clean(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const country = clean(window.__REEVYS_MARKET__?.country).toUpperCase();

  function preferredSystem() {
    if (country === 'GB' || country === 'IE') return 'UK';
    if (country === 'AU' || country === 'NZ') return 'AU';
    if (country === 'BR') return 'BR';
    if (EU.has(country)) return 'EU';
    return 'US';
  }

  function convertUs(value, system) {
    if (!value || system === 'US') return value;
    const offset = { UK: 4, AU: 4, EU: 32, BR: 34 }[system];
    if (!offset) return value;
    return String(value).replace(/\d+/g, (number) =>
      String(parseInt(number, 10) + offset)
    );
  }

  function fitPosition(value) {
    const text = norm(value);
    if (/(skinny|slim|fitted|tight|bodycon|close)/.test(text)) return 0;
    if (/(oversized|oversize)/.test(text)) return 100;
    if (/(relaxed|loose|roomy)/.test(text)) return 82;
    return 50;
  }

  function stretchPosition(value) {
    const text = norm(value);
    if (/(non|none|no stretch|without)/.test(text)) return 0;
    if (/(slight|low|little|minimal)/.test(text)) return 33.333;
    if (/(medium|moderate|mid)/.test(text)) return 66.667;
    if (/(high|very|maximum|max)/.test(text)) return 100;
    return 50;
  }

  function fitValue(value) {
    return clean(value).replace(/\s+fit$/i, '') || clean(value);
  }

  function stretchValue(value) {
    return clean(value).replace(/\s+stretch$/i, '') || clean(value);
  }

  function thicknessValue(value) {
    const text = norm(value);
    if (/^(thin|light|lightweight)$/.test(text)) return 'Lightweight';
    if (/^(regular|medium|mid|midweight)$/.test(text)) return 'Midweight';
    if (/^(thick|heavy|heavyweight)$/.test(text)) return 'Heavyweight';
    return clean(value);
  }

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function scale(label, displayValue, rawValue, stopCount, position) {
    const block = el('div', 'reevys-fit-scale');
    const head = el('div', 'reevys-fit-scale-head');
    head.append(
      el('span', 'reevys-fit-scale-name', label),
      el('span', 'reevys-fit-scale-value', displayValue)
    );
    block.appendChild(head);

    const track = el('div', 'reevys-fit-track');
    track.style.setProperty('--reevys-fit-position', `${position}%`);
    track.setAttribute('role', 'img');
    track.setAttribute('aria-label', `${label}: ${rawValue}`);

    for (let index = 0; index < stopCount; index += 1) {
      const stop = el('span', 'reevys-fit-stop');
      stop.style.left = `${(index / (stopCount - 1)) * 100}%`;
      track.appendChild(stop);
    }

    track.appendChild(el('span', 'reevys-fit-marker'));
    block.appendChild(track);
    return block;
  }

  function parseRows(section) {
    return Array.from(section.querySelectorAll('.reevys-pi-row'))
      .map((row) => ({
        label: clean(row.querySelector('.reevys-pi-label')?.textContent),
        value: clean(row.querySelector('.reevys-pi-value')?.textContent),
      }))
      .filter((pair) => pair.label && pair.value);
  }

  function enhanceFitProfile() {
    document.querySelectorAll('.reevys-pi-content').forEach((content) => {
      const section = Array.from(
        content.querySelectorAll(':scope > .reevys-pi-section')
      ).find((item) =>
        /^fit$/i.test(clean(item.querySelector('.reevys-pi-kicker')?.textContent))
      );

      if (!section) return;

      const pairs = parseRows(section);
      const fit = pairs.find((pair) => /fit/.test(norm(pair.label)));
      const stretch = pairs.find((pair) => /stretch/.test(norm(pair.label)));
      if (!fit && !stretch) return;

      const profile = el('section', 'reevys-pi-fit');
      profile.dataset.reevysFitEnhanced = 'true';
      profile.appendChild(el('h4', 'reevys-pi-subhead', 'Fit & feel'));

      const body = el('div', 'reevys-fit-body');

      if (fit) {
        body.appendChild(
          scale('Fit', fitValue(fit.value), fit.value, 3, fitPosition(fit.value))
        );
      }

      if (stretch) {
        body.appendChild(
          scale(
            'Stretch',
            stretchValue(stretch.value),
            stretch.value,
            4,
            stretchPosition(stretch.value)
          )
        );
      }

      profile.appendChild(body);
      section.replaceWith(profile);
    });
  }

  function enhanceFabric() {
    document.querySelectorAll('.reevys-pi-content').forEach((content) => {
      const section = Array.from(
        content.querySelectorAll(':scope > .reevys-pi-section')
      ).find((item) =>
        /^details$/i.test(clean(item.querySelector('.reevys-pi-kicker')?.textContent))
      );

      if (!section) return;

      const pairs = parseRows(section);
      if (!pairs.length) return;

      const composition = pairs.find((pair) => /composition/.test(norm(pair.label)));
      const material = pairs.find((pair) => /material/.test(norm(pair.label)));
      const thickness = pairs.find((pair) => /thickness|weight/.test(norm(pair.label)));
      const extras = pairs.filter(
        (pair) => pair !== composition && pair !== material && pair !== thickness
      );

      const fabric = el('section', 'reevys-pi-fabric');
      fabric.dataset.reevysFabricEnhanced = 'true';
      fabric.appendChild(el('h4', 'reevys-pi-subhead', 'Fabric'));

      const meta = [];
      if (material) meta.push(material.value);
      if (thickness) meta.push(thicknessValue(thickness.value));

      if (meta.length) {
        fabric.appendChild(el('p', 'reevys-pi-fabric-meta', meta.join(' · ')));
      }

      if (composition) {
        fabric.appendChild(
          el('p', 'reevys-pi-fabric-composition', composition.value)
        );
      }

      if (extras.length) {
        fabric.appendChild(
          el(
            'p',
            'reevys-pi-fabric-extra',
            extras.map((pair) => `${pair.label}: ${pair.value}`).join(' · ')
          )
        );
      }

      section.replaceWith(fabric);
    });
  }

  function enhanceCare() {
    document.querySelectorAll('.reevys-pi-content').forEach((content) => {
      Array.from(content.querySelectorAll(':scope > .reevys-pi-section')).forEach(
        (section) => {
          const kicker = section.querySelector('.reevys-pi-kicker');
          if (!/^care$/i.test(clean(kicker?.textContent))) return;
          section.classList.add('reevys-pi-care');
          kicker.classList.remove('reevys-pi-kicker');
          kicker.classList.add('reevys-pi-subhead');
          kicker.textContent = 'Care';
        }
      );
    });
  }

  function findSystemColumn(table, drawer) {
    const saved = Number(drawer.dataset.reevysSystemColumn);
    if (Number.isInteger(saved) && saved >= 0) return saved;

    const headers = Array.from(table.querySelectorAll('thead th'));
    const index = headers.findIndex((th) =>
      ['us', 'ussize'].includes(norm(th.textContent).replace(/\s+/g, ''))
    );

    if (index >= 0) drawer.dataset.reevysSystemColumn = String(index);
    return index;
  }

  function applySizeSystem(drawer) {
    const table = drawer.querySelector('.reevys-pm-table');
    if (!table) return;

    const index = findSystemColumn(table, drawer);
    if (index < 0) return;

    const system = drawer.dataset.reevysSizeSystem || preferredSystem();
    const header = table.querySelectorAll('thead th')[index];
    if (header) header.textContent = system;

    table.querySelectorAll('tbody tr').forEach((row) => {
      const cell = row.children[index];
      if (!cell) return;

      if (!cell.dataset.reevysUsValue) {
        cell.dataset.reevysUsValue = clean(cell.textContent);
      }

      cell.textContent = convertUs(cell.dataset.reevysUsValue, system);
    });
  }

  function addSystemControl(drawer) {
    const controls = drawer.querySelector('[data-reevys-pm-controls]');
    const table = drawer.querySelector('.reevys-pm-table');
    if (!controls || !table) return;

    const index = findSystemColumn(table, drawer);
    if (index < 0) return;

    if (!drawer.dataset.reevysSizeSystem) {
      drawer.dataset.reevysSizeSystem = preferredSystem();
    }

    let select = controls.querySelector('[data-reevys-size-system]');

    if (!select) {
      const wrap = el('label', 'reevys-pm-system');
      const selectWrap = el('span', 'reevys-pm-select-wrap');
      select = el('select', 'reevys-pm-select');
      select.dataset.reevysSizeSystem = 'true';
      select.setAttribute('aria-label', 'Size system');

      SYSTEMS.forEach((system) => {
        const option = el('option', '', `${system} size`);
        option.value = system;
        select.appendChild(option);
      });

      select.addEventListener('change', () => {
        drawer.dataset.reevysSizeSystem = select.value;
        applySizeSystem(drawer);
      });

      selectWrap.appendChild(select);
      wrap.appendChild(selectWrap);
      controls.prepend(wrap);
    }

    select.value = drawer.dataset.reevysSizeSystem;
  }

  function applyMarketUnitDefault(drawer) {
    if (drawer.dataset.reevysMarketUnitApplied === 'true') return;
    if (!drawer.classList.contains('is-open')) return;

    drawer.dataset.reevysMarketUnitApplied = 'true';
    if (country !== 'US') return;

    const inch = Array.from(drawer.querySelectorAll('.reevys-pm-unit')).find(
      (button) => /^in$/i.test(clean(button.textContent))
    );

    if (inch && !inch.classList.contains('is-active')) inch.click();
  }

  function enhanceDrawer() {
    const drawer = document.getElementById('reevys-product-measurements');
    if (!drawer) return;

    addSystemControl(drawer);
    applySizeSystem(drawer);
    applyMarketUnitDefault(drawer);
  }

  function enhance() {
    enhanceFitProfile();
    enhanceFabric();
    enhanceCare();
    enhanceDrawer();
  }

  let timer;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(enhance, 30);
  };

  const observer = new MutationObserver(schedule);

  function init() {
    enhance();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
